import Icon from '../components/Icon.vue'

Icon.register({"home":{"width":576,"height":512,"paths":[{"d":"M488 312.7V456C488 469.3 477.3 480 464 480H348C341.4 480 336 474.6 336 468V356C336 349.4 330.6 344 324 344H252C245.4 344 240 349.4 240 356V468C240 474.6 234.6 480 228 480H112C98.7 480 88 469.3 88 456V312.7C88 309.1 89.6 305.7 92.4 303.4L280.4 148.6C284.8 145 291.2 145 295.7 148.6L483.7 303.4C486.4 305.7 488 309.1 488 312.7zM571.6 251.8L488 182.9V44.4C488 37.8 482.6 32.4 476 32.4H420C413.4 32.4 408 37.8 408 44.4V117L318.5 43.3C300.8 28.7 275.2 28.7 257.5 43.3L4.4 251.8C-0.7 256-1.4 263.6 2.8 268.7L28.3 299.7C32.5 304.8 40.1 305.5 45.2 301.3L280.4 107.6C284.8 104 291.2 104 295.7 107.6L530.9 301.3C536 305.5 543.6 304.8 547.8 299.7L573.3 268.7C577.5 263.5 576.7 256 571.6 251.8z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/home.js
// module id = null
// module chunks = 